module.exports = __webpack_public_path__ + "static/media/gryphon_musee_urbanlandscape_4.5d501405.jpg";